import { useState, useCallback } from 'react';
import { GridPaginationModel, GridSortModel, GridFilterModel } from '@mui/x-data-grid';

const INITIAL_PAGE_SIZE = 10;

interface UseEntityListStateOptions {
	defaultSortField: string;
	defaultSortOrder?: 'asc' | 'desc';
	initialPageSize?: number;
}

export function useEntityListState({
	defaultSortField,
	defaultSortOrder = 'asc',
	initialPageSize = INITIAL_PAGE_SIZE,
}: UseEntityListStateOptions) {
	const [searchValue, setSearchValue] = useState('');
	const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
		page: 0,
		pageSize: initialPageSize,
	});
	const [sortModel, setSortModel] = useState<GridSortModel>([
		{ field: defaultSortField, sort: defaultSortOrder },
	]);
	const [filterModel, setFilterModel] = useState<GridFilterModel>({ items: [] });

	const handlePaginationModelChange = useCallback((model: GridPaginationModel) => {
		setPaginationModel(model);
	}, []);

	const handleSortModelChange = useCallback((model: GridSortModel) => {
		setSortModel(model);
	}, []);

	const handleFilterModelChange = useCallback((model: GridFilterModel) => {
		setFilterModel(model);
		setPaginationModel(prev => ({ ...prev, page: 0 }));
	}, []);

	const handleSearch = useCallback((value: string) => {
		setSearchValue(value);
		setPaginationModel(prev => ({ ...prev, page: 0 }));
	}, []);

	const resetPage = useCallback(() => {
		setPaginationModel(prev => ({ ...prev, page: 0 }));
	}, []);

	return {
		searchValue,
		paginationModel,
		sortModel,
		filterModel,
		handlePaginationModelChange,
		handleSortModelChange,
		handleFilterModelChange,
		handleSearch,
		resetPage,
	};
}
